import { loadMigrationFiles } from '@w/db/migrate/browser'
import { hashString } from '@w/utils'
import initSql from './migrations/202610100001_init.sql?raw'
import cardDerivationSql from './migrations/202610210001_card_derivation.sql?raw'
import pageSearchSql from './migrations/202610210002_page_search.sql?raw'
import pageReadonlySql from './migrations/202611010001_page_readonly.sql?raw'
import flashcardReviewCountSql from './migrations/202611030001_flashcard_review_count.sql?raw'

export const flashcardsClientMigrations = loadMigrationFiles([
  ['202610100001_init.sql', initSql],
  ['202610210001_card_derivation.sql', cardDerivationSql],
  ['202610210002_page_search.sql', pageSearchSql],
  ['202611010001_page_readonly.sql', pageReadonlySql],
  ['202611030001_flashcard_review_count.sql', flashcardReviewCountSql],
])

export function schemaIdOf(sql: string): string {
  return hashString(sql).slice(0, 8)
}

export const flashcardsClientSchemaId = schemaIdOf(initSql + cardDerivationSql + pageSearchSql + pageReadonlySql + flashcardReviewCountSql)
export const flashcardsBrowserWorkspaceMigrations = flashcardsClientMigrations

/** Identity of the current client schema, including custom indexes and triggers. */
export const flashcardsDeviceSchemaId = 'r17:' + schemaIdOf(initSql + cardDerivationSql + pageSearchSql + pageReadonlySql + flashcardReviewCountSql)
